
import { Stack, Typography } from "@mui/material";
import React from "react";  

interface NoDataComponentProps {
  label:string
}

  export const NoDataComponent =  ({label}:NoDataComponentProps) => (
      <Stack alignItems="center" justifyContent="center" width={"100"}>
        <Typography variant="h4">{label}</Typography>
      </Stack>
    );